module.exports = __webpack_public_path__ + "static/media/53.caf8f6ad.png";